import React from 'react'
import { useSelector } from 'react-redux'
import LgyAlertDialog from 'app/components/util/lgy-alert-dialog/LgyAlertDialog'
import LgyModalDialog from 'app/components/util/lgy-modal-dialog/LgyModalDialog'

import '../style/error-style.scss'

const ErrorModal = ({ error, dismissErrors }) => {
  const helpTicketUrl = useSelector(state => state.serverProperties?.helpTicketUrl)
  const shouldDisplayHelpAnchorTag = error && error.shouldDisplayHelpLink && helpTicketUrl && helpTicketUrl.length > 0

  return <div className='lgy-error-modal'>
    <LgyModalDialog show={!!error} onClose={dismissErrors}>
      <LgyAlertDialog type='error' heading={(error && error.error) ? error.error : 'Oops!'} paragraph>
        <div className='error-message'>
          {(error && error.message) ? error.message : 'An unknown error occurred.'}{' Please submit a help ticket to let us know about this error.'}&nbsp;&nbsp;
          {shouldDisplayHelpAnchorTag && <div><a className='usa-button' href={helpTicketUrl} target="_blank" rel="noopener noreferrer">Submit a help ticket</a></div>}
          {(error && error.lgyRequestUuid) && `Include reference number: ${error.lgyRequestUuid}`}
        </div>
      </LgyAlertDialog>
    </LgyModalDialog>
  </div>
}

export default ErrorModal